import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/common/Card';
import Badge from '../components/common/Badge';
import { AlertTriangle, Calendar, Filter, MapPin, Search, Download, Tag } from 'lucide-react';
import { priorityAlerts, allDeputies } from '../utils/dummyData';
import { bindaRegions } from '../utils/mapData';
const CasesAlerts = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRisk, setSelectedRisk] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedDeputy, setSelectedDeputy] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedBinda, setSelectedBinda] = useState('all');
  const categories = ['Ideologi', 'Politik', 'Ekonomi', 'Sosial Budaya', 'Pertahanan Keamanan'];
  const filteredAlerts = priorityAlerts.filter(alert => {
    const matchesSearch = alert.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRisk = selectedRisk === 'all' || alert.riskLevel === selectedRisk;
    const matchesStatus = selectedStatus === 'all' || alert.status === selectedStatus;
    const matchesDeputy = selectedDeputy === 'all' || alert.deputy === selectedDeputy;
    const matchesCategory = selectedCategory === 'all' || alert.category === selectedCategory;
    const matchesBinda = selectedBinda === 'all' || alert.bindaRegion === selectedBinda;
    return matchesSearch && matchesRisk && matchesStatus && matchesDeputy && matchesCategory && matchesBinda;
  });
  return <div className="space-y-6" data-id="element-317">
      <div className="flex items-center justify-between" data-id="element-318">
        <div data-id="element-319">
          <h1 className="text-2xl font-bold text-white" data-id="element-320">
            Cases & Alerts Management
          </h1>
          <p className="text-sm text-gray-400 mt-1" data-id="element-321">
            Kelola dan monitor semua kasus dan alert aktif
          </p>
        </div>
        <div className="flex items-center space-x-3" data-id="element-322">
          <button className="flex items-center px-4 py-2 bg-gray-800 hover:bg-gray-700 text-white rounded-lg border border-gray-700" data-id="element-323">
            <Download className="h-4 w-4 mr-2" data-id="element-324" />
            Export
          </button>
          <button className="flex items-center px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg" data-id="element-325">
            <AlertTriangle className="h-4 w-4 mr-2" data-id="element-326" />
            Create New Alert
          </button>
        </div>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-327">
        <Card className="p-4" data-id="element-328">
          <div className="flex justify-between items-start" data-id="element-329">
            <div data-id="element-330">
              <p className="text-sm text-gray-400" data-id="element-331">Total Cases</p>
              <h3 className="text-2xl font-bold text-white mt-1" data-id="element-332">24</h3>
            </div>
            <div className="w-10 h-10 rounded-lg bg-blue-900/30 flex items-center justify-center" data-id="element-333">
              <AlertTriangle className="h-5 w-5 text-blue-400" data-id="element-334" />
            </div>
          </div>
        </Card>
        <Card className="p-4" data-id="element-335">
          <div className="flex justify-between items-start" data-id="element-336">
            <div data-id="element-337">
              <p className="text-sm text-gray-400" data-id="element-338">Critical</p>
              <h3 className="text-2xl font-bold text-red-400 mt-1" data-id="element-339">3</h3>
            </div>
            <div className="w-10 h-10 rounded-lg bg-red-900/30 flex items-center justify-center" data-id="element-340">
              <AlertTriangle className="h-5 w-5 text-red-400" data-id="element-341" />
            </div>
          </div>
        </Card>
        <Card className="p-4" data-id="element-342">
          <div className="flex justify-between items-start" data-id="element-343">
            <div data-id="element-344">
              <p className="text-sm text-gray-400" data-id="element-345">Ongoing</p>
              <h3 className="text-2xl font-bold text-yellow-400 mt-1" data-id="element-346">8</h3>
            </div>
            <div className="w-10 h-10 rounded-lg bg-yellow-900/30 flex items-center justify-center" data-id="element-347">
              <AlertTriangle className="h-5 w-5 text-yellow-400" data-id="element-348" />
            </div>
          </div>
        </Card>
        <Card className="p-4" data-id="element-349">
          <div className="flex justify-between items-start" data-id="element-350">
            <div data-id="element-351">
              <p className="text-sm text-gray-400" data-id="element-352">Resolved</p>
              <h3 className="text-2xl font-bold text-green-400 mt-1" data-id="element-353">13</h3>
            </div>
            <div className="w-10 h-10 rounded-lg bg-green-900/30 flex items-center justify-center" data-id="element-354">
              <AlertTriangle className="h-5 w-5 text-green-400" data-id="element-355" />
            </div>
          </div>
        </Card>
      </div>
      {/* Enhanced Filters */}
      <Card className="p-4" data-id="element-356">
        <div className="space-y-3" data-id="element-357">
          <div className="flex items-center justify-between" data-id="element-358">
            <div className="flex items-center" data-id="element-359">
              <Filter className="h-4 w-4 text-gray-400 mr-2" data-id="element-360" />
              <span className="text-sm text-gray-400 font-semibold" data-id="element-361">
                Advanced Filters:
              </span>
            </div>
            <button onClick={() => {
            setSearchTerm('');
            setSelectedRisk('all');
            setSelectedStatus('all');
            setSelectedDeputy('all');
            setSelectedCategory('all');
            setSelectedBinda('all');
          }} className="text-xs text-cyan-400 hover:text-cyan-300" data-id="element-362">
              Reset All Filters
            </button>
          </div>
          {/* First Row */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-363">
            <div className="relative" data-id="element-364">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-365" />
              <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search cases..." className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-366" />
            </div>
            <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} className="bg-gray-800 text-sm text-white border border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-367">
              <option value="all" data-id="element-368">All Categories</option>
              {categories.map(cat => <option key={cat} value={cat} data-id="element-369">
                  {cat}
                </option>)}
            </select>
            <select value={selectedRisk} onChange={e => setSelectedRisk(e.target.value)} className="bg-gray-800 text-sm text-white border border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-370">
              <option value="all" data-id="element-371">All Risk Levels</option>
              <option value="critical" data-id="element-372">Critical</option>
              <option value="high" data-id="element-373">High</option>
              <option value="moderate" data-id="element-374">Moderate</option>
              <option value="low" data-id="element-375">Low</option>
            </select>
          </div>
          {/* Second Row */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-376">
            <select value={selectedStatus} onChange={e => setSelectedStatus(e.target.value)} className="bg-gray-800 text-sm text-white border border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-377">
              <option value="all" data-id="element-378">All Status</option>
              <option value="ongoing" data-id="element-379">Ongoing</option>
              <option value="monitoring" data-id="element-380">Monitoring</option>
              <option value="resolved" data-id="element-381">Resolved</option>
            </select>
            <select value={selectedDeputy} onChange={e => setSelectedDeputy(e.target.value)} className="bg-gray-800 text-sm text-white border border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-382">
              <option value="all" data-id="element-383">All Deputies</option>
              {allDeputies.map(deputy => <option key={deputy} value={deputy} data-id="element-384">
                  {deputy}
                </option>)}
            </select>
            <select value={selectedBinda} onChange={e => setSelectedBinda(e.target.value)} className="bg-gray-800 text-sm text-white border border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-385">
              <option value="all" data-id="element-386">All BINDA</option>
              {bindaRegions.map(binda => <option key={binda} value={binda} data-id="element-387">
                  {binda}
                </option>)}
            </select>
            <div className="flex items-center px-3 py-2 bg-gray-800 rounded-lg border border-gray-700" data-id="element-388">
              <Calendar className="h-4 w-4 text-gray-400 mr-2" data-id="element-389" />
              <span className="text-sm text-gray-400" data-id="element-390">Last 30 days</span>
            </div>
          </div>
          {/* Active Filters Display */}
          {(selectedCategory !== 'all' || selectedRisk !== 'all' || selectedStatus !== 'all' || selectedDeputy !== 'all' || selectedBinda !== 'all' || searchTerm) && <div className="flex flex-wrap gap-2 pt-2 border-t border-gray-700" data-id="element-391">
              <span className="text-xs text-gray-400" data-id="element-392">Active filters:</span>
              {searchTerm && <Badge variant="blue" data-id="element-393">Search: {searchTerm}</Badge>}
              {selectedCategory !== 'all' && <Badge variant="purple" data-id="element-394">Category: {selectedCategory}</Badge>}
              {selectedRisk !== 'all' && <Badge variant="orange" data-id="element-395">Risk: {selectedRisk}</Badge>}
              {selectedStatus !== 'all' && <Badge variant="yellow" data-id="element-396">Status: {selectedStatus}</Badge>}
              {selectedDeputy !== 'all' && <Badge variant="cyan" data-id="element-397">Deputy: {selectedDeputy}</Badge>}
              {selectedBinda !== 'all' && <Badge variant="green" data-id="element-398">BINDA: {selectedBinda}</Badge>}
            </div>}
        </div>
      </Card>
      {/* Cases List */}
      <Card data-id="element-399">
        <div className="p-4 border-b border-gray-800 flex justify-between items-center" data-id="element-400">
          <h2 className="text-lg font-semibold text-white" data-id="element-401">
            Cases & Alerts List
          </h2>
          <span className="text-sm text-gray-400" data-id="element-402">
            Showing {filteredAlerts.length} of {priorityAlerts.length} cases
          </span>
        </div>
        <div className="overflow-x-auto" data-id="element-403">
          <table className="w-full" data-id="element-404">
            <thead data-id="element-405">
              <tr className="bg-gray-800" data-id="element-406">
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-407">
                  Case ID
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-408">
                  Title
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-409">
                  Category
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-410">
                  Location
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-411">
                  Risk Level
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-412">
                  Deputy
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-413">
                  BINDA
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-414">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-415">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800" data-id="element-416">
              {filteredAlerts.map(alert => <tr key={alert.id} className="hover:bg-gray-800/50 cursor-pointer" onClick={() => navigate(`/case/${alert.id}`)} data-id="element-417">
                  <td className="px-4 py-3 whitespace-nowrap text-sm font-medium text-cyan-400" data-id="element-418">
                    {alert.id}
                  </td>
                  <td className="px-4 py-3 text-sm text-white max-w-xs truncate" data-id="element-419">
                    {alert.title}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm" data-id="element-420">
                    <div className="flex items-center text-gray-300" data-id="element-421">
                      <Tag className="h-3 w-3 mr-1 text-purple-400" data-id="element-422" />
                      {alert.category}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-300" data-id="element-423">
                    <div className="flex items-center" data-id="element-424">
                      <MapPin className="h-4 w-4 mr-1 text-gray-400" data-id="element-425" />
                      {alert.location}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap" data-id="element-426">
                    <Badge variant={alert.riskLevel === 'critical' ? 'red' : alert.riskLevel === 'high' ? 'orange' : alert.riskLevel === 'moderate' ? 'yellow' : 'green'} data-id="element-427">
                      {alert.riskLevel}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-300" data-id="element-428">
                    {alert.deputy}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-300" data-id="element-429">
                    {alert.bindaRegion}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap" data-id="element-430">
                    <Badge variant={alert.status === 'ongoing' ? 'red' : alert.status === 'monitoring' ? 'yellow' : 'green'} data-id="element-431">
                      {alert.status}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap text-sm" data-id="element-432">
                    <button onClick={e => {
                  e.stopPropagation();
                  navigate(`/case/${alert.id}`);
                }} className="text-cyan-400 hover:text-cyan-300" data-id="element-433">
                      View Details
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {filteredAlerts.length === 0 && <div className="p-8 text-center" data-id="element-434">
            <AlertTriangle className="h-12 w-12 text-gray-600 mx-auto mb-3" data-id="element-435" />
            <p className="text-gray-400" data-id="element-436">
              No cases found matching your filters
            </p>
            <button onClick={() => {
          setSearchTerm('');
          setSelectedRisk('all');
          setSelectedStatus('all');
          setSelectedDeputy('all');
          setSelectedCategory('all');
          setSelectedBinda('all');
        }} className="mt-3 text-cyan-400 hover:text-cyan-300 text-sm" data-id="element-437">
              Clear all filters
            </button>
          </div>}
      </Card>
    </div>;
};
export default CasesAlerts;